export interface HsTouchNavigationSettings {
  /** Multiplier for one-finger orbit; 1 rotates by the same angle per CSS pixel as a mouse drag. */
  rotateSensitivity: number;
  /** Multiplier for two-finger pan; 1 pans by the same amount per CSS pixel as a middle-button drag. */
  panSensitivity: number;
  /** Exponent applied to the pinch ratio; 1 keeps the content under the fingers at finger scale. */
  zoomSensitivity: number;
  /** Pinch ratios are ignored while the fingers are closer than this, where one pixel of noise is a large ratio. */
  minPinchDistancePx: number;
  /** Upper bound for the pinch ratio of a single pointer event (and its inverse as the lower bound). */
  maxPinchScalePerEvent: number;
  /** A touch that moves farther than this is a drag, not a tap, and starts the orbit. */
  tapMaxMovementPx: number;
  /** A touch held longer than this is not a tap. */
  tapMaxDurationMs: number;
  /** Maximum time between two taps of a double tap. */
  doubleTapMaxDelayMs: number;
  /** Maximum distance between two taps of a double tap. */
  doubleTapMaxDistancePx: number;
}

export const HS_DEFAULT_TOUCH_NAVIGATION_SETTINGS: Readonly<HsTouchNavigationSettings> = {
  rotateSensitivity: 1,
  panSensitivity: 1,
  zoomSensitivity: 1,
  minPinchDistancePx: 24,
  maxPinchScalePerEvent: 2,
  tapMaxMovementPx: 10,
  tapMaxDurationMs: 300,
  doubleTapMaxDelayMs: 350,
  doubleTapMaxDistancePx: 40,
};
